import { axios } from '@/utils';

export const getFactureService = async () => (await axios.get('/facture')).data.data;
export const getFactureIdService = async (id: string) =>
  (await axios.get(`/facture/${id}`)).data.data;
export const postFactureService = async (id: string) =>
  (await axios.post(`/facture/${id}`)).data.data;
export const putFacturePayService = async (id?: string, values? : any) =>
  (await axios.put(`/facture/${id}`, values)).data.data;
export const changeTipsFactureService = async (id?: string, values?: any)  =>
  (await axios.put(`/facture/change-tips/${id}`, values)).data.data;
export const logsTipsFactureService = async (id: string, values: any) =>
  (await axios.get(`/facture/change-tips/${id}`, values)).data.data;
export const changeMethodsFactureService = async (id: string, values: any)  =>
  (await axios.put(`/facture/change-method/${id}`, values)).data.data;
export const getMethodsFactureService =async (id: string) =>
  (await axios.get(`/facture/change-method/${id}`)).data.data;
export const rePrinterFactureService = async (id?: string) =>
  (await axios.get(`/facture/print-facture/${id}`)).data.data;
